import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Details panel for a selected Business Auditor sub-agent.
 * Shows document summary (Accountant), upload placeholder, guardrails.
 * Linked documents are shown in the left sidebar (AuditorBusinessPanel).
 */
const SubAgentDetailsPanel = ({ subAgent, documentSummary, summaryCreatedAt, onGenerateSummary, summaryLoading, showDocumentSummary }) => {
  if (!subAgent) return null;

  const { id, name, uploadTargetDir } = subAgent;
  const basePath = '01_auditor';
  const isAccountant = id === 'accountant';

  const hasDocumentSummary = isAccountant && showDocumentSummary;
  return (
    <div className={`subagent-details-panel${hasDocumentSummary ? ' subagent-details-panel--summary-expanded' : ''}`}>
      {!isAccountant && <h3 className="subagent-details-title">{name}</h3>}
      {isAccountant && showDocumentSummary && (
        <div className="subagent-details-summary">
          <h4 className="subagent-details-summary-title">Document summary</h4>
          <div className="subagent-details-summary-body">
            {documentSummary ? (
              <>
                <div className="subagent-details-summary-text subagent-details-summary-markdown">
                  <ReactMarkdown>{documentSummary}</ReactMarkdown>
                </div>
                {summaryCreatedAt && (
                  <div className="subagent-details-summary-meta">Generated {new Date(summaryCreatedAt).toLocaleString()}</div>
                )}
              </>
            ) : (
              <p className="subagent-details-summary-empty">
                No summary yet. Click &quot;Generate summary&quot; or ask the Accountant to analyze the document below.
              </p>
            )}
          </div>
          <button
            type="button"
            className="subagent-details-summary-btn"
            onClick={onGenerateSummary}
            disabled={summaryLoading}
          >
            {summaryLoading ? 'Generating…' : 'Generate summary'}
          </button>
        </div>
      )}
      {!isAccountant && uploadTargetDir && (
        <p className="subagent-details-upload-hint">
          Upload to {basePath}/{uploadTargetDir}/ — coming in Phase 2.
        </p>
      )}
      {!isAccountant && (
        <div className="subagent-details-placeholder">
          <span className="subagent-details-placeholder-label">Guardrails & instructions</span>
          <span className="subagent-details-placeholder-text">Editable in a later phase.</span>
        </div>
      )}
    </div>
  );
};

export default SubAgentDetailsPanel;
